module.exports = __webpack_public_path__ + "static/media/error-x.76332aff.jpg";